<template>
    <div>
        <fundation-layout
            :email-label="emailLabel"
            :email-suffix="emailSuffix"
            :extra-login-data="extraLoginData"
        >
            <LayoutMain></LayoutMain>
        </fundation-layout>
    </div>
</template>

<script>
import LayoutMain from '@/components/partials/ui/LayoutMain';
import LoadingFullscreen from '@/components/partials/ui/LoadingFullscreen';
import {FundationLayout} from 'fundation-app-vuejs';

export default {
    name: 'App',
    components: {
        LayoutMain,
        LoadingFullscreen,
        FundationLayout
    },
    computed: {
        emailLabel () {
            return window.config.use_apivalo_auth === true ? 'NNi' : null;
        },
        emailSuffix () {
            return window.config.use_apivalo_auth === true ? window.config.email_suffix : null;
        },
        extraLoginData () {
            return window.config.use_apivalo_auth === true ? {user_type: 'SESAME'} : null;
        },
        // version (){
        //     try{
        //         return VERSION;
        //     }catch(e){
        //         console.error(e);
        //         return '';
        //     }
        // },
    },
};
</script>

<style lang="scss">
@import "./assets/styles/app";
@import "./assets/styles/element-variables.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue